<template>
  <span v-loading.fullscreen.lock="fullScreenLoading">

    <el-dialog
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      :append-to-body="true"
      title=""
      width="80%"
      top="8vh"
       @opened="openDialog"
    >
        <div class="center" style="width:100%;height:75vh;">
                <video :ref="myref" :id="myref" class="video-js vjs-default-skin vjs-big-play-centered" ></video>
        </div>

    </el-dialog>
  </span>
</template>

<script>

import { defineComponent, onMounted, ref } from "vue";
import videojs from "video.js";

export default {
  name: 'VideoShow',
  props: {
    firstList: {
      type: Object,
      default: () => {
        return {}
      }
    },
    course: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  inject: [],
  data() {
    return {
      dialogVisible: false,
      fullScreenLoading: false,
      isError: false,
      myref:"videoPlayer",
      src:"",
      poster:"",
      player: null,
      options: {
                autoplay: false,
                controls: true,
                playbackRates: [0.5, 1, 1.5, 2],
                sources: [
                    {
                        src:"",
                        type: "video/mp4"
                    }
                ],
                bigPlayButton: true,
                controlBar: {
                    fullscreenToggle: true,
                    // 音量条的横向还是纵向显示
                    volumePanel: {
                    inline: false,
                },
                
            }, 
            }
    }
  },
  watch: {

  },
  created() { },
  methods: {
    show(url) {

        this.options.sources[0].src = url
        this.src = url
        this.myref = "videoPlayer_" + Date.now()



        this.dialogVisible = true

        // if(this.$refs.videoPlayer)
        // {
        //     this.createPlayer()
        // }

        
        // const videoRef = ref() // 获取video元素的引用实例对象
        // const src = ref()
        // const poster = ref()
        // const player = ref(null)
        // player.value = videojs(videoRef.value,
        // {
        //     // 视频配置项
        //     //是否显示播放按钮
        //     bigPlayButton: true, 
        //     // 封面图
        //     posterImage: true,
        //     errorDisplay: false,
        //     //设置小喇叭音量键
        //     controlBar: {
        //         fullscreenToggle: true,
        //         // 音量条的横向还是纵向显示
        //         volumePanel: {
        //         inline: false,
        //         },
        //     },
        //     muted: true // //静音模式   解决首次页面加载播放。
        // }) ,
        // () => {
        //     player.value.on("play"), () => {
        //     }
        //     // 设置默认2倍速
        //     player.value.playbackRate(2)
        // }

        // if()
        // {

        // }
 



    },
    createPlayer()
    {

        if(!this.player)
        {
            this.player = videojs(this.myref, this.options, function onPlayerReady() {
     
            })  
        }
        else
        {
           this.player.src(              {
                src:this.src,
                type: "video/mp4"
            })


        }

    },
    handleClose()
    {
        this.dialogVisible = false

        if (this.player) {
            this.player.pause()
        }
    },
    openDialog()
    {
   
        this.createPlayer()
    },


  },
  beforeDestroy() {

        if (this.player) {
            this.player.pause()
        }
    }
}
</script>


<style>
    .video-js{
        width:100%;
        height:75vh;
    }
    .vjs-big-play-button {
        height: 3em !important;
        width: 3em !important;
        line-height: 3em !important;
        border-radius: 50% !important;
    }

    .vjs-button > .vjs-icon-placeholder:before {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 2em;
    }

    .vjs-slider-horizontal .vjs-volume-level:before {
        top: -0.333333333333333em;
        right: -0.5em;
    }

    .vjs-playback-rate .vjs-playback-rate-value {
        font-size: 1.8em;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .vjs-control-bar {
        background: rgba(0,0,0,.8) !important;
    }

    .video-js .vjs-play-progress, .video-js .vjs-volume-level {
        background: linear-gradient(to right, #FF7B02, #FFA604) !important;
    }

    .video-js:hover .vjs-big-play-button, .vjs-custom-skin > .video-js .vjs-big-play-button:focus, .vjs-custom-skin > .video-js .vjs-big-play-button:active {
        background: linear-gradient(to right, #FF7B02, #FFA604) !important;
        opacity: .7;
    }

    .vjs-big-play-button .vjs-icon-placeholder {
        font-size: 70px !important;
    }

    .vjs-error .vjs-error-display:before {
        color: #fff !important;
        content: 'X' !important;
        font-family: Arial, Helvetica, sans-serif !important;
        font-size: 4.5em !important;
        left: 0 !important;
        line-height: 1.8 !important;
        margin-top: -0.5em !important;
        position: absolute !important;
        text-shadow: 0.05em 0.05em 0.1em #000 !important;
        text-align: center !important;
        top: 50% !important;
        vertical-align: middle !important;
        width: 100% !important;
    }
</style>
